<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="550">
      <v-card>
        <v-card-title class="pb-0">
          <v-spacer></v-spacer>
          <v-btn class="ma-0" depressed flat fab small @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="confirm_form" data-vv-scope="confirm_form" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <v-icon size="150" :color="type && typeColors[type] ? typeColors[type] : 'error'" class="">{{ type === 'success' ? 'check_circle' : 'error_outline'}}</v-icon>
              </v-flex>
              <v-flex xs12 text-xs-center headline>
                {{ alertTitle }}
              </v-flex>
              <v-flex xs12 text-xs-center subheading mt-3>
                <span v-html="alertText"></span>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <template v-if="type === 'perms'">
            <v-btn flat @click="dialog = false">Cancel</v-btn>
            <v-btn
              v-if="
                $store.state.user.projects_count < 2 &&
                $store.state.user.keywords_count < 200
              "
              color="warning"
              @click="wizardDialog = true;"
            >Configure Package</v-btn>
            <v-btn color="warning" @click="dialog = false;" href="https://app.kolyom.co.il/" target="_blank">Kolyom.co.il</v-btn>
          </template>
          <template v-else-if="type === 'login'">
            <v-btn flat @click="dialog = false">Cancel</v-btn>
            <v-btn color="warning" @click="dialog = false; $router.push({name: 'Login'})">REGISTER FOR FREE!</v-btn>
          </template>
          <template v-else-if="type === 'tenClub'">
            <v-btn flat @click="dialog = false">Cancel</v-btn>
            <SendOfferModal></SendOfferModal>
          </template>
          <v-btn v-else flat color="info" @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <WizardModal v-if="wizardDialog" :wizardDialog="wizardDialog"></WizardModal>
  </v-layout>
</template>

<script>
export default {
  name: 'AlertModal',
  props: ['alertModalDialog', 'type', 'alertTitle', 'alertText'],
  data () {
    return {
      dialog: this.alertModalDialog,
      wizardDialog: false,
      typeColors: {
        error: 'error',
        warning: 'warning',
        success: 'success',
        info: 'info',
        perms: 'warning',
        login: 'warning',
        tenClub: 'warning'
      }
    }
  },
  mounted () {
    this.$eventEmitter
      .$on('wizardDialog', (value) => {
        this.wizardDialog = value
      })
  },
  beforeDestroy () {
    this.$eventEmitter.$off('wizardDialog')
  },
  watch: {
    alertModalDialog: {
      handler () {
        this.dialog = this.alertModalDialog
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('alertModalDialog', this.dialog)
      }
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/alerts/AlertModal.vue